import { render, staticRenderFns } from "./weeklayout.vue?vue&type=template&id=363b9f52"
import script from "./weeklayout.vue?vue&type=script&lang=ts"
export * from "./weeklayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports